import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CameraService, CAMERA_MODEL, TCameraModel } from '@monorepo/services';
import {
  IDefectList,
  IOperationsList,
  TBctxHeaderItem,
  TOperationAndSelectedIssueList,
  TOperationIssueAndMarkedLocations,
  TRejectReasonSelectionData,
} from '@monorepo/types';
import { BCTXComputationHelper, EventUtil, InputAppAPIHelperUtil } from '@monorepo/utils';
import { FilterMasterdataListComponent } from '../filter-masterdata-list/filter-masterdata-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-operation-or-reject-reason-selection',
  templateUrl: './operation-or-reject-reason-selection.component.html',
  styleUrls: ['./operation-or-reject-reason-selection.component.scss'],
})
export class OperationOrRejectReasonSelectionComponent implements OnInit {
  @Input() isImageCapturingEnabled: boolean = false;
  @Input() isOperationSelection: boolean = true;
  @Input() isRecentDefectiveSelection: boolean = false;
  @Input() bctxHeader: TBctxHeaderItem[] = [];
  @Input() allOperationOrRejectReasonList: IOperationsList[] | IDefectList[] | TOperationIssueAndMarkedLocations[] = [];
  @Input() operationOrRejectReasonList: IOperationsList[] | IDefectList[] | TOperationIssueAndMarkedLocations[] = [];
  @Input() selectedOperationOrRejectReasonList:
    | IOperationsList[]
    | IDefectList[]
    | TOperationIssueAndMarkedLocations[] = [];
  @Output() cancel = new EventEmitter<'CANCEL'>();
  @Output() clearAll = new EventEmitter<'CLEAR_ALL'>();
  @Output() next = new EventEmitter<IOperationsList[] | TOperationIssueAndMarkedLocations[]>();
  @Output() done = new EventEmitter<TRejectReasonSelectionData>();
  @Output() onViewAll = new EventEmitter<string[]>();
  @Output() onOperationOrRejectReasonSelect = new EventEmitter<IOperationsList[] | IDefectList[]>();

  CAMERA_MODEL = CAMERA_MODEL.identity(EventUtil.getBucketIdFromUniqueEventId(BCTXComputationHelper.getUniqueVId()));
  #bucketInfo: TCameraModel['bucketInfo'] = this.CAMERA_MODEL.bucketInfo;

  constructor(
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private cameraService: CameraService,
    private modalCtrl: ModalController,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    console.log('[operationOrRejectReasonList]', this.operationOrRejectReasonList, this.isRecentDefectiveSelection);
  }

  async openCamera() {
    this.cameraService.openModal(this.CAMERA_MODEL).then((v) => {
      console.log('Dismiss Data', v.data);
      if (v.data) this.#bucketInfo = v.data;
    });
  }

  handleOperationOrRejectReasonSelection(selectedList: any) {
    if (this.isRecentDefectiveSelection)
      this.selectedOperationOrRejectReasonList = selectedList as TOperationIssueAndMarkedLocations[];
    else this.selectedOperationOrRejectReasonList = selectedList as IDefectList[] | IOperationsList[];
  }

  async onViewAllClick() {
    const modal = await this.modalCtrl.create({
      component: FilterMasterdataListComponent,
      componentProps: {
        type: 'OPERATION_OR_DEFECT',
        lists: this.allOperationOrRejectReasonList,
        preSelectedLists: this.operationOrRejectReasonList,
        title: 'operation_or_reject_reason_selection.listOfOperations',
      },
      cssClass: 'm-modal_reject_flow_component',
      backdropDismiss: false,
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (res.data) {
        const t = res.data as IOperationsList[] | IDefectList[];
        this.onViewAll.emit(t.map((x) => x.name));
      }
    });
  }

  handleClearAll() {
    console.log('[Clear All clicked]');
    this.selectedOperationOrRejectReasonList = [];
    this.clearAll.emit('CLEAR_ALL');
  }

  handleCancel() {
    this.cancel.emit('CANCEL');
  }

  handleNextOrDone() {
    if (this.selectedOperationOrRejectReasonList.length === 0)
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('input_app_common.alert'),
        this.translate.instant('operation_or_reject_reason_selection.alertMessage'),
      );
    else {
      console.log('[FINAL_SELECTED_OPERATION_OR_ISSUE_LIST]', this.selectedOperationOrRejectReasonList);
      if (this.isOperationSelection) this.next.emit(this.selectedOperationOrRejectReasonList as IOperationsList[]);
      else if (this.isRecentDefectiveSelection)
        this.next.emit(this.selectedOperationOrRejectReasonList as TOperationIssueAndMarkedLocations[]);
      else
        this.done.emit({
          rejectedReasons: this.selectedOperationOrRejectReasonList as IDefectList[],
          bucketInfo: this.#bucketInfo,
        });
    }
  }
}
